import { Fragment, useMemo, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Button, Card, Col, DatePicker, Row, Select, Spin } from "antd";
import { BoothTragetperMonth } from "./booth-terget-per-month";
import { BoothRequest } from "../booth-sales/Booth-Request";
import { useGetDashboardBooth } from "features/dashboard/use-cases/get-dashboardbooth";
import incrase from "assets/Dashboard/graph.svg";
import { booth } from "components/side-bar/utils";
import dayjs from "dayjs";
import { FilterOutlined } from "@ant-design/icons";
import { useGetDashboardCardCommon } from "features/dashboard/use-cases/get-commonDropDown";

const { RangePicker } = DatePicker;

export const BoothTargetViewGraph = () => {
  const today = dayjs();
  const currentYear = today.year();

  // ✅ state
  const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs]>('' as any);
  const [selectedEvent, setSelectedEvent] = useState<string | undefined>();
  const [selectedCategory, setSelectedCategory] = useState<string | undefined>();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);

  const chartRef = useRef<HighchartsReact.RefObject>(null);

  // ✅ dropdowns from API
  const { data: eventsData } = useGetDashboardCardCommon({ Flag: "events" });

  // ✅ fetch data
  const { data, isFetching } = useGetDashboardBooth({
    FromDate: dateRange?.[0]?.format("YYYY-MM-DD") || "",
    ToDate: dateRange?.[1]?.format("YYYY-MM-DD") || "",
    Year: selectedYear,
    EventId: selectedEvent,
    CategoryId: selectedCategory,
  });

  // ✅ years dropdown (last 16 years)
  const years = Array.from({ length: 16 }, (_, i) => {
    const year = currentYear - 10 + i;
    
return { label: year.toString(), value: year };
  });

  // ✅ chart options
  const chartOptions: Highcharts.Options = useMemo(() => {
    const categories =
      data?.BoothGraphDatalst?.map((item: any) => item.EventName) || [];
    const targetData =
      data?.BoothGraphDatalst?.map((item: any) => item.Target) || [];
    const bookedData =
      data?.BoothGraphDatalst?.map((item: any) => item.TotalCount) || [];

    return {
      chart: { type: "column" },
      title: { text: "Total Booth per Event" },
      xAxis: {
        categories,
        title: { text: "Events" },
      },
      yAxis: {
        min: 0,
        title: { text: "Count" },
      },
      credits: { enabled: false },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            inside: true,
            style: { color: "#000", textOutline: "none", fontWeight: "bold" },
          },
          grouping: true,
          groupPadding: 0.2,
          pointPadding: 0.1,
        },
      },
      legend: { enabled: true },
      colors: ["#fce647", "#ff69b4"], // yellow and pink
      series: [
        { name: "Target", type: "column", data: targetData },
        { name: "Booked", type: "column", data: bookedData },
      ],
    };
  }, [data]);

  // ✅ handle reset
  const handleReset = () => {
    setDateRange([today, today]);
    setSelectedYear(currentYear);
    setSelectedEvent(undefined);
    setSelectedCategory(undefined);
  };

  return (
    <Fragment>
      {/* Filters */}
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col span={24} style={{ padding: "0" }}>
          <Card className="filtr_card filt_repn">
            {/* Date Range */}
            <RangePicker
              style={{ marginRight: 16 }}
              value={dateRange}
              onChange={(dates: any) => {
                setDateRange(dates);
                if (dates?.[0]) {
                  setSelectedYear(dates[0].year());
                }
              }}
            />

            {/* Year Filter */}
            <Select
              options={years}
              value={selectedYear}
              onChange={(value) => {
                setSelectedYear(value);
                setDateRange([
                  dayjs().year(value).startOf("year"),
                  dayjs().year(value).endOf("year"),
                ]);
              }}
              style={{ width: 120, marginRight: 16 }}
              placeholder="Select Year"
            />

            {/* Event Filter */}
            <Select
              showSearch
              allowClear
              optionFilterProp="label"
              placeholder="Filter by Event"
              value={selectedEvent}
              onChange={(value) => setSelectedEvent(value)}
              style={{ width: 150, marginRight: 16 }}
              dropdownRender={(menu) => (
                <div>
                  <div
                    style={{
                      padding: 8,
                      fontWeight: 500,
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <FilterOutlined style={{ marginRight: 6 }} />
                    Select Event
                  </div>
                  {menu}
                </div>
              )}
              options={
                eventsData?.dropDownList?.map((e: any) => ({
                  label: e.Name,
                  value: e.Id,
                })) || []
              }
            />

            {/* Buttons */}
            <Button
              type="primary"
              style={{ marginLeft: "16px", marginRight: "10px" }}
            >
              Filter
            </Button>
            <Button onClick={handleReset}>Cancel</Button>
          </Card>
        </Col>
      </Row>

      {/* Top Cards */}
      <Row gutter={[16, 16]} className="respn_row">
        {data?.BoothTopDatalst?.map((item: any, index: number) => (
          <Col span={6} key={index}>
            <div className="sales_regis">
              <Spin spinning={isFetching}>
                <Card style={{ backgroundColor: booth[item.Name] || "#fff" }}>
                  <div >
                    
                    <p style={{ fontSize: 16, color: "#fff" }}>{item.Name}</p>
                  </div>
                  <div className="card_img_t">
                  <h2 style={{ fontSize: 16, color: "#fff" }}>{item.Value}</h2>
                  <img src={incrase} alt="" width={40} height={40} />
                  </div>
                </Card>
              </Spin>
            </div>
          </Col>
        ))}
      </Row>

      {/* Graphs */}
      <Row gutter={[16, 16]} className="row_gap">
        <Col span={24}>
          <Spin spinning={isFetching}>
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          </Spin>
        </Col>

        <Col span={12} className="respn_col">
          <Spin spinning={isFetching}>
            <BoothTragetperMonth
              dateRange={dateRange}
              chartRef={chartRef}
              selectedYear={selectedYear}
              selectedCategory={selectedCategory}
              selectedEvent={selectedEvent}
            />
          </Spin>
        </Col>

        <Col span={12} className="respn_col">
          <Spin spinning={isFetching}>
            <BoothRequest data={data?.BoothCircleGraphDatalst} />
          </Spin>
        </Col>
      </Row>
    </Fragment>
  );
};
